
import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';


export function initItemlistSlider(
    selector = '.itemboxList.swiper'
) {
    document.querySelectorAll(selector).forEach((sliderEl) => {
        new Swiper(sliderEl, {
            modules: [Autoplay, Navigation, Pagination],
            spaceBetween: 32,
            speed: 300,
            slidesPerView: 'auto',
            pagination: false,
            navigation:{
                nextEl: sliderEl.querySelector('.swiper-button-next'),
                prevEl: sliderEl.querySelector('.swiper-button-prev'),
            }
        });
    });
}

export function initItemlistBlogSlider(
    selector = '.blog__content .itemboxList.swiper'
) {
    document.querySelectorAll(selector).forEach((sliderEl) => {
        new Swiper(sliderEl, {
            modules: [Autoplay, Navigation, Pagination],
            spaceBetween: 32,
            speed: 300,
            slidesPerView: 'auto',
            pagination: false,
            navigation:{
                nextEl: sliderEl.querySelector('.swiper-button-next'),
                prevEl: sliderEl.querySelector('.swiper-button-prev'),
            }
        });
    });
}

export function initItemlistCrosssellerSlider(
    selector = '.itemcardCrosssellerList .itemboxList.swiper'
) {
    document.querySelectorAll(selector).forEach((sliderEl) => {
        new Swiper(sliderEl, {
            modules: [Autoplay, Navigation, Pagination],
            spaceBetween: 32,
            speed: 300,
            slidesPerView: 1.2,
            pagination: false,
            navigation:{
                nextEl: sliderEl.querySelector('.swiper-button-next'),
                prevEl: sliderEl.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                425: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
                1024: {
                    slidesPerView: 2,
                },
                1250: {
                    slidesPerView: 3,
                },
            }
        });
    });
}